"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorTokens = void 0;
const React = require("react");
const nano_theme_1 = require("nano-theme");
const palettes = require("./palettes");
const Markup_1 = require("./Markup");
const style_1 = require("./style");
const lightClass = (0, nano_theme_1.rule)((0, style_1.css)(palettes.light));
const darkClass = (0, nano_theme_1.rule)((0, style_1.css)(palettes.dark));
const ColorTokens = (props) => {
    var _a;
    const theme = (0, nano_theme_1.useTheme)();
    return React.createElement(Markup_1.Markup, Object.assign(Object.assign({}, props), { className: ((_a = props.className) !== null && _a !== void 0 ? _a : "") + (theme.isLight ? lightClass : darkClass) }));
};
exports.ColorTokens = ColorTokens;
